import script from "./partial-dialog-card-confirmation-icon-switcher.vue?vue&type=script&lang=ts"
export * from "./partial-dialog-card-confirmation-icon-switcher.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__